import { render, staticRenderFns } from "./EventMessage.vue?vue&type=template&id=0da4e5a6&"
import script from "./EventMessage.vue?vue&type=script&lang=js&"
export * from "./EventMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports